var _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgScorecardFoundation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10C9.23857 10 7 8.56731 7 6.8C7 5.03269 9.23857 3.6 12 3.6M12 10C14.7614 10 17 11.4327 17 13.2C17 14.9673 14.7614 16.4 12 16.4M12 10V3.6M12 10L12 16.4M12 3.6C13.8507 3.6 15.4665 4.24352 16.3311 5.2M12 3.6V2M12 16.4L12 18M12 16.4C10.1493 16.4 8.53346 15.7565 7.66894 14.8",
    stroke: "#9594AF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.75,
    y1: 21.25,
    x2: 21.25,
    y2: 21.25,
    stroke: "#9594AF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgScorecardFoundation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/scorecard-foundation.ba901c26.svg";
export { ForwardRef as ReactComponent };